import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/draft-experiments/$id/generation/variants/$variantId/$tab")(
  {},
);
